import * as React from "react";

import { styled } from "../../../styled-components";
import { withTheme } from "styled-components";
import { RuntimeTheme } from "../../../lib/theme/theme";
import { defined } from "common/Support";

// Surely there is a better way built into JS
function dateString(): string {
    let hours = new Date().getHours();
    let minutes = new Date().getMinutes().toString();

    if (hours > 12) hours = hours - 12;
    if (hours === 0) hours = 12;

    if (minutes.length === 1) minutes = "0" + minutes;
    return hours + ":" + minutes;
}

const AndroidStatusBarWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background-color: black;
    color: white;
    height: 24px;
    width: 100%;
    padding-right: 16px;
`;

function AndroidStatusBar() {
    return (
        <AndroidStatusBarWrapper>
            <svg width="57" height="16" viewBox="0 0 57 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M50 1.875V1L47 1V1.875H44V15H53V1.875H50Z"
                    fill="white"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M21 15H35V1L21 15Z" fill="white" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.977295 4.01593L9.99992 15L19.0226 4.01593C16.5117 2.12256 13.3869 1 9.99992 1C6.61294 1 3.48814 2.12256 0.977295 4.01593Z"
                    fill="white"
                />
            </svg>
            {dateString()}
        </AndroidStatusBarWrapper>
    );
}

function StatusBarDrawing(props: { theme: RuntimeTheme }) {
    const time = dateString();
    // these artisnal tuned constants brought to you by taking screenshots and measuring
    let timeX = 28;
    if (time.length > 4) {
        timeX -= 7;
    }

    const width = props.theme.builderWidth;
    // Assumes that values greater than 375 are going to be shown the tablet status bar.
    if (width <= 375) {
        const translate = `translate(${width - 375}, 0)`;
        return (
            <svg width={width} height="44" viewBox={`0 0 ${width} 44`} fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    transform={translate}
                    d="M339.418 17.0615C338.485 17.0615 338.165 17.1271 337.836 17.3135C337.575 17.4609 337.377 17.6708 337.238 17.9464C337.062 18.295 337 18.6346 337 19.6223V24.3831C337 25.3707 337.062 25.7103 337.238 26.0589C337.377 26.3345 337.575 26.5444 337.836 26.6918C338.165 26.8783 338.485 26.9438 339.418 26.9438H354.581C355.514 26.9438 355.835 26.8783 356.164 26.6918C356.424 26.5444 356.623 26.3345 356.762 26.0589C356.938 25.7103 357 25.3707 357 24.3831V19.6223C357 18.6346 356.938 18.295 356.762 17.9464C356.623 17.6708 356.424 17.4609 356.164 17.3135C355.835 17.1271 355.514 17.0615 354.581 17.0615H339.418ZM339.418 16.0027H354.581C355.77 16.0027 356.201 16.1337 356.636 16.3798C357.07 16.6259 357.411 16.987 357.644 17.4471C357.876 17.9072 358 18.3636 358 19.6223V24.3831C358 25.6417 357.876 26.0981 357.644 26.5582C357.411 27.0183 357.07 27.3794 356.636 27.6255C356.201 27.8716 355.77 28.0027 354.581 28.0027H339.418C338.23 28.0027 337.799 27.8716 337.364 27.6255C336.929 27.3794 336.588 27.0183 336.356 26.5582C336.124 26.0981 336 25.6417 336 24.3831V19.6223C336 18.3636 336.124 17.9072 336.356 17.4471C336.588 16.987 336.929 16.6259 337.364 16.3798C337.799 16.1337 338.23 16.0027 339.418 16.0027ZM359 19.885C359.805 20.2437 360.328 21.0782 360.328 22.0027C360.328 22.9271 359.805 23.7616 359 24.1203V19.885Z"
                />
                <path
                    transform={translate}
                    d="M339.709 18.0027H354.291C354.885 18.0027 355.101 18.0702 355.318 18.1969C355.535 18.3237 355.706 18.5097 355.822 18.7468C355.938 18.9838 356 19.2189 356 19.8673V24.138C356 24.7864 355.938 25.0215 355.822 25.2585C355.706 25.4956 355.535 25.6816 355.318 25.8084C355.101 25.9351 354.885 26.0027 354.291 26.0027H339.709C339.115 26.0027 338.9 25.9351 338.682 25.8084C338.465 25.6816 338.294 25.4956 338.178 25.2585C338.062 25.0215 338 24.7864 338 24.138V19.8673C338 19.2189 338.062 18.9838 338.178 18.7468C338.294 18.5097 338.465 18.3237 338.682 18.1969C338.9 18.0702 339.115 18.0027 339.709 18.0027Z"
                />
                <path
                    transform={translate}
                    d="M323.33 18.2773C325.546 18.2774 327.677 19.1289 329.283 20.6557C329.404 20.7735 329.597 20.772 329.716 20.6523L330.872 19.4857C330.933 19.4249 330.966 19.3427 330.966 19.2571C330.965 19.1715 330.931 19.0897 330.87 19.0297C326.655 14.9901 320.005 14.9901 315.79 19.0297C315.729 19.0896 315.694 19.1715 315.693 19.257C315.693 19.3426 315.726 19.4249 315.787 19.4857L316.943 20.6523C317.062 20.7722 317.256 20.7737 317.376 20.6557C318.983 19.1288 321.114 18.2773 323.33 18.2773ZM323.33 22.073C324.548 22.0729 325.722 22.5254 326.624 23.3427C326.746 23.4586 326.938 23.4561 327.057 23.337L328.212 22.1703C328.273 22.1091 328.307 22.0261 328.306 21.9398C328.305 21.8536 328.27 21.7713 328.207 21.7113C325.459 19.1549 321.203 19.1549 318.455 21.7113C318.393 21.7713 318.358 21.8536 318.357 21.9399C318.356 22.0262 318.39 22.1092 318.451 22.1703L319.605 23.337C319.724 23.4561 319.916 23.4586 320.038 23.3427C320.94 22.526 322.113 22.0735 323.33 22.073ZM325.549 24.8573C325.611 24.7967 325.645 24.7133 325.643 24.6268C325.641 24.5403 325.604 24.4584 325.54 24.4003C324.264 23.3214 322.396 23.3214 321.12 24.4003C321.056 24.4583 321.019 24.5402 321.017 24.6267C321.015 24.7132 321.049 24.7967 321.111 24.8573L323.108 26.873C323.167 26.9322 323.247 26.9656 323.33 26.9656C323.413 26.9656 323.493 26.9322 323.552 26.873L325.549 24.8573Z"
                />
                <path
                    transform={translate}
                    d="M294.666 23.0027H295.666C296.219 23.0027 296.666 23.4504 296.666 24.0027V26.0027C296.666 26.555 296.219 27.0027 295.666 27.0027H294.666C294.114 27.0027 293.667 26.555 293.667 26.0027V24.0027C293.667 23.4504 294.114 23.0027 294.666 23.0027ZM299.333 21.0027H300.333C300.885 21.0027 301.333 21.4504 301.333 22.0027V26.0027C301.333 26.555 300.885 27.0027 300.333 27.0027H299.333C298.781 27.0027 298.333 26.555 298.333 26.0027V22.0027C298.333 21.4504 298.781 21.0027 299.333 21.0027ZM304 18.6693H305C305.552 18.6693 306 19.1171 306 19.6693V26.0027C306 26.555 305.552 27.0027 305 27.0027H304C303.447 27.0027 303 26.555 303 26.0027V19.6693C303 19.1171 303.447 18.6693 304 18.6693ZM309.666 16.336C310.219 16.336 310.666 16.7837 310.666 17.336V26.0027C310.666 26.555 310.219 27.0027 309.666 27.0027H308.666C308.114 27.0027 307.666 26.555 307.666 26.0027V17.336C307.666 16.7837 308.114 16.336 308.666 16.336H309.666Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M65.4551 26.5L69.9999 16L59.4999 20.5448H65.4551V26.5Z"
                />
                <text
                    fontFamily="-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif"
                    fontSize="14px"
                    fontWeight="normal"
                    x={timeX}
                    y="26">
                    {`${dateString()}`}
                </text>
                {width < 500 && (
                    <path
                        fill="black"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M292 5C292 5.74052 292.123 6.47884 292.123 7.21936V8C292.123 20.1503 282.273 30 270.123 30H104.877C92.7272 30 82.8774 20.1503 82.8774 8V7.21936C82.8774 6.47884 83 5.74052 83 5C83 2.23858 80.7614 0 78 0H297C294.239 0 292 2.23858 292 5Z"
                    />
                )}
            </svg>
        );
    } else {
        const translateTablet = `translate(-170, 0)`;

        return (
            <svg width={width} height="24" viewBox={`0 0 ${width} 24`} fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    transform={translateTablet}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1173.5 6.50001H1156.5C1155.12 6.50001 1154 7.6193 1154 9.00001V15.5C1154 16.8807 1155.12 18 1156.5 18H1173.5C1174.88 18 1176 16.8807 1176 15.5V9.00001C1176 7.6193 1174.88 6.50001 1173.5 6.50001ZM1155 9.00012C1155 8.17169 1155.67 7.50012 1156.5 7.50012H1173.5C1174.33 7.50012 1175 8.17169 1175 9.00012V15.5001C1175 16.3285 1174.33 17.0001 1173.5 17.0001H1156.5C1155.67 17.0001 1155 16.3285 1155 15.5001V9.00012ZM1178.25 12.0001C1178.25 11.0747 1177.75 10.2668 1177 9.83455V14.1656C1177.75 13.7334 1178.25 12.9255 1178.25 12.0001Z"
                />
                <path
                    transform={translateTablet}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1157 8.50011H1173C1173.55 8.50011 1174 8.94783 1174 9.50011V15.0001C1174 15.5524 1173.55 16.0001 1173 16.0001H1157C1156.45 16.0001 1156 15.5524 1156 15.0001V9.50011C1156 8.94783 1156.45 8.50011 1157 8.50011Z"
                />

                <path
                    transform={translateTablet}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1129.37 9.69885L1129.37 9.464C1127.31 7.62122 1124.66 6.605 1121.88 6.605C1119.09 6.605 1116.44 7.627 1114.38 9.4792L1114.37 9.71384L1115.59 10.9352L1115.81 10.9423C1117.49 9.46527 1119.63 8.65246 1121.88 8.65246C1124.12 8.65246 1126.26 9.45975 1127.93 10.9277L1128.15 10.9204L1129.37 9.69885ZM1126.69 12.1343L1126.7 12.3723L1125.48 13.5974L1125.27 13.6094C1124.3 12.8415 1123.12 12.4241 1121.88 12.4241C1120.63 12.4241 1119.44 12.8466 1118.48 13.6231L1118.26 13.6115L1117.04 12.3868L1117.05 12.1492C1118.4 11.0039 1120.1 10.3766 1121.88 10.3766C1123.65 10.3766 1125.35 10.9983 1126.69 12.1343ZM1121.98 17.105H1121.75L1119.72 15.0728C1119.65 15.0019 1119.66 14.8842 1119.74 14.8264C1120.37 14.385 1121.11 14.1482 1121.88 14.1482C1122.64 14.1482 1123.38 14.38 1124 14.8127C1124.08 14.8703 1124.09 14.9885 1124.02 15.0597L1121.98 17.105Z"
                />
                <path
                    transform={translateTablet}
                    d="M1142.91 16.2848C1142.7 16.7829 1141.96 16.629 1141.96 16.0862V13.0449C1141.96 12.7688 1141.73 12.5449 1141.46 12.5449H1138.41C1137.87 12.5449 1137.72 11.8016 1138.22 11.5861L1145.34 8.5019C1145.76 8.32192 1146.18 8.74355 1146 9.15938L1142.91 16.2848Z"
                />
                <text
                    fontFamily="-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif"
                    fontSize="14px"
                    fontWeight="normal"
                    x={timeX}
                    y="18">
                    {`${dateString()}`}
                </text>
            </svg>
        );
    }
}

const StatusBarContainer = styled.div<{ drawBackground: boolean }>`
    background-color: ${p => (p.drawBackground ? p.theme.navBar.bgColor : "transparent")};
    z-index: 45;
    position: sticky;
    height: ${p => p.theme.statusBar.height}px;
    font-family: "Roboto";

    svg {
        fill: ${p => p.theme.statusBar.color};
    }
`;

interface Props {
    theme: RuntimeTheme;
    isSplash: boolean;
}

class StatusBar extends React.Component<Props> {
    private interval: number = 0;

    public componentDidMount() {
        this.interval = window.setInterval(() => this.setState({ time: Date.now() }), 1000);
    }

    public componentWillUnmount() {
        window.clearInterval(this.interval);
    }

    public render() {
        const isIOS = defined(this.props.theme).navBar.style === "iOS";
        const content = isIOS ? <StatusBarDrawing theme={this.props.theme} /> : <AndroidStatusBar />;
        return <StatusBarContainer drawBackground={!isIOS && !this.props.isSplash}>{content}</StatusBarContainer>;
    }
}

export default withTheme(StatusBar);
